import React from 'react';
import Title from "../../customer/ProductsCustomer/Title";
import CheckoutAdviserRegister from "./Checkout/CheckoutAdviserRegister";
import useStyles from "../Cotizar/VehiculoForm/Checkout/styles";

function AdviserRegisterPage(props) {
    const classes = useStyles();
    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    backgroundColor: "#F5F6F9",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "50px"
                    }}
                >
                    <Title
                        title={"REGISTRO"}
                        subtitle={"Ingrese sus datos y luego presione siguiente"}
                    />
                </div>

                <div className={classes.formBox} style={{alignSelf: "center", marginBottom:"48px"}}>
                    <CheckoutAdviserRegister/>
                </div>

            </div>
        </React.Fragment>
    );
}

export default AdviserRegisterPage;